import React from "react";
import "../components/css/style.css";
import "../components/css/legal.css";
import BreadcrumbIllustration from "../assets/imgs/img_banner.png";

export default function RefundPolicySection() {
    const handleHomeClick = (e) => {
        e.preventDefault();
        window.location.href = "/";
    };

    return (
        <div className="abt-section">
            <div className="abt-container">
                <div className="abt-left">
                    <h1 className="abt-title">
                        <span className="abt-highlight">Refund Policy</span>
                    </h1>

                    <div className="abt-breadcrumb">
                        <span className="abt-crumb abt-home" onClick={handleHomeClick}>Home</span>
                        <span className="abt-crumb abt-active">Refund Policy</span>
                    </div>
                </div>

                <div className="abt-right">
                    <div className="abt-image-wrapper">
                        <img
                            src={BreadcrumbIllustration}
                            alt="Illustration"
                            className="abt-image"
                        />
                    </div>
                    <div className="abt-glow"></div>
                    <div className="abt-glow abt-glow-second"></div>
                </div>
            </div>

            <section className="pp-section">
                <div className="pp-container">
                    <div className="pp-content">
                        <p>
                            At RhythmGrowthLab, we are committed to delivering high-quality services. However, due to the nature of our digital services, we maintain a strict <strong>No Refund Policy</strong>. Please read this policy carefully before engaging our services or making any payment.
                        </p>

                        <h2>1. No Refund Policy</h2>
                        <p>
                            All fees paid to RhythmGrowthLab are <strong>non-refundable and non-transferable</strong> under any circumstances, including but not limited to:
                        </p>
                        <ul>
                            <li>Website Development</li>
                            <li>Mobile App Development (Android & iOS)</li>
                            <li>Brand Identity Design</li>
                            <li>Digital Marketing campaigns</li>
                            <li>Performance Marketing (Meta / Google Ads)</li>
                            <li>SEO services</li>
                            <li>Social Media Management</li>
                            <li>Content Creation</li>
                            <li>Consultation fees</li>
                            <li>Setup fees or advance payments</li>
                        </ul>
                        <p>
                            Once a project or service has commenced, no refund requests, cancellations, chargebacks, reversals, or partial payment disputes shall be entertained.
                        </p>

                        <h2>2. Why No Refunds?</h2>
                        <p>
                            Our services involve significant time, expertise, resources, and third-party costs that are incurred upfront. These include:
                        </p>
                        <ul>
                            <li>Developer hours and project planning</li>
                            <li>Designer time and creative resources</li>
                            <li>Ad account setup and campaign configuration</li>
                            <li>Third-party tool subscriptions and licenses</li>
                            <li>Server resources and hosting setup</li>
                            <li>Domain registration and configuration</li>
                            <li>Market research and competitor analysis</li>
                        </ul>
                        <p>
                            Once work has begun, these resources cannot be recovered, and therefore refunds cannot be provided.
                        </p>

                        <h2>3. Service Commencement Definition</h2>
                        <p>
                            A service or project is considered "commenced" when any of the following occurs:
                        </p>
                        <ul>
                            <li>Initial payment or deposit is made</li>
                            <li>Project kickoff meeting has been conducted</li>
                            <li>Any work (research, design, development, strategy) has been initiated</li>
                            <li>Third-party services have been procured on Client's behalf</li>
                            <li>Ad campaigns have been configured or launched</li>
                            <li>Any deliverable has been shared with Client for review</li>
                        </ul>

                        <h2>4. No Partial Refunds</h2>
                        <p>
                            RhythmGrowthLab does not offer partial refunds for:
                        </p>
                        <ul>
                            <li>Partially completed projects</li>
                            <li>Services that Client decides not to continue</li>
                            <li>Change of business priorities or requirements</li>
                            <li>Internal team changes or management decisions</li>
                        </ul>
                        <p>
                            Once a project phase has been completed or work has been delivered, the full amount for that phase remains payable and non-refundable.
                        </p>

                        <h2>5. No Refunds for Change of Mind</h2>
                        <p>
                            Refunds will not be provided due to:
                        </p>
                        <ul>
                            <li>Change of mind about project direction</li>
                            <li>Change in business strategy or goals</li>
                            <li>Dissatisfaction with design aesthetics after multiple revisions (revisions are provided as per agreement)</li>
                            <li>Delays caused by Client's unavailability or slow feedback</li>
                            <li>Internal budget cuts or financial constraints</li>
                        </ul>

                        <h2>6. Platform Policy Violations</h2>
                        <p>
                            RhythmGrowthLab is not responsible for and shall not provide refunds due to:
                        </p>
                        <ul>
                            <li>Ad account bans, suspensions, or restrictions by Meta, Google, or any platform</li>
                            <li>App rejection or removal from App Store, Play Store, or any platform</li>
                            <li>Website delisting or penalties from search engines</li>
                            <li>Copyright or trademark claims against Client-provided content</li>
                            <li>Policy violations resulting from Client's business practices or content</li>
                            <li>Third-party platform downtime, changes, or policy updates</li>
                        </ul>
                        <p>
                            The Client is solely responsible for ensuring compliance with all platform policies. No refunds will be issued for platform-related issues.
                        </p>

                        <h2>7. No Refunds for Results-Based Expectations</h2>
                        <p>
                            RhythmGrowthLab does not guarantee specific results from digital marketing, SEO, or advertising campaigns. Therefore, no refunds will be provided based on:
                        </p>
                        <ul>
                            <li>ROI, conversion rates, or sales figures</li>
                            <li>Website traffic, rankings, or positions</li>
                            <li>Leads generated or cost per lead</li>
                            <li>Impressions, clicks, or engagement metrics</li>
                            <li>App downloads or user acquisition numbers</li>
                        </ul>
                        <p>
                            All campaigns are managed with professional expertise and best practices, but results vary based on multiple factors beyond our control including market conditions, competition, and Client's product/service quality.
                        </p>

                        <h2>8. Service Cancellation Policy</h2>
                        <p>
                            If Client wishes to cancel ongoing services:
                        </p>
                        <ul>
                            <li>A written cancellation notice must be provided</li>
                            <li>No refund will be issued for work already completed or in progress</li>
                            <li>Client remains liable for all fees incurred up to cancellation date</li>
                            <li>Any outstanding invoices must be paid in full</li>
                        </ul>

                        <h2>9. No Chargebacks</h2>
                        <p>
                            By engaging our services and making a payment, Client agrees not to initiate any chargeback, payment reversal, or dispute with their bank, credit card company, or payment processor. Any unauthorized chargeback will result in:
                        </p>
                        <ul>
                            <li>Immediate suspension of all active services</li>
                            <li>Termination of all ongoing projects</li>
                            <li>Referral to a collections agency</li>
                            <li>Legal action for recovery of the original amount plus:</li>
                            <ul>
                                <li>Chargeback processing fees</li>
                                <li>Legal fees and court costs</li>
                                <li>Collection agency fees</li>
                                <li>Interest at 18% per annum</li>
                            </ul>
                        </ul>

                        <h2>10. Dispute Resolution</h2>
                        <p>
                            If Client has any concerns about services provided, they agree to:
                        </p>
                        <ul>
                            <li>First contact RhythmGrowthLab in writing to discuss concerns</li>
                            <li>Allow reasonable time (up to 15 business days) for resolution attempts</li>
                            <li>Engage in good-faith discussions before any legal action</li>
                            <li>Not initiate chargebacks or payment disputes as a first recourse</li>
                        </ul>
                        <p>
                            We are committed to client satisfaction and will make reasonable efforts to address legitimate concerns through revisions, additional support, or service adjustments—but not through refunds.
                        </p>

                        <h2>11. Exceptional Circumstances</h2>
                        <p>
                            The only scenario where a refund may be considered, at RhythmGrowthLab's sole discretion:
                        </p>
                        <ul>
                            <li>RhythmGrowthLab fails to deliver any work whatsoever (no kickoff, no work initiated, no resources allocated)</li>
                            <li>Written refund request is submitted within 7 days of payment</li>
                            <li>No services have commenced as defined in Section 3</li>
                        </ul>
                        <p>
                            Even in such cases, any third-party costs incurred (domain registration, tool subscriptions, etc.) will be deducted from the refund amount. All decisions regarding refunds are final and binding.
                        </p>

                        <h2>12. Acknowledgment of Policy</h2>
                        <p>
                            By making a payment to RhythmGrowthLab—whether as a deposit, advance, setup fee, or full project payment—Client acknowledges that they have read, understood, and agreed to this No Refund Policy. Client confirms that they have had the opportunity to ask questions and seek clarification before making any payment.
                        </p>

                        <h2>13. Policy Updates</h2>
                        <p>
                            RhythmGrowthLab reserves the right to modify or update this Refund Policy at any time without prior notice. Changes will be published on this page with an updated effective date. However, the policy in effect at the time of payment shall apply to that payment.
                        </p>

                        <h2>14. Governing Law & Jurisdiction</h2>
                        <p>
                            This Refund Policy and all related matters shall be governed by the laws of <strong>India</strong>. Any disputes arising from or relating to this policy or refund claims shall be subject to the <strong>exclusive jurisdiction</strong> of the courts in <strong>Delhi, India</strong>.
                        </p>

                        <h2>15. Contact Information</h2>
                        <p>
                            If you have any questions about this Refund Policy before making a payment, please contact us at:<br />
                            <strong>Email:</strong> info@rhythmgrowthlab.com
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}